var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('drukker'),_c('brieven'),_c('s-m-s'),_c('emails'),_c('huisarts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }